import React from "react";
import PropTypes from "prop-types";

// ----------------------------------------------------------------------------
import { MediaQuery } from "@sisuwellness/web-components";
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------------
import PageContainer from "../PageContainer";
import ThinHeader from "../ThinHeader";
import routes from "constants/routes";

import { PORTAL_IMAGE } from "constants/imagePath";
import { Button, HeaderContainer, ItemsContainer, MemberLogin, MobileLogo } from "./styled";
import LanguageSwitcher from "components/LanguageSwitcher";

// ----------------------------------------------------------------------------

const BaseMemberViewWithoutMenu = ({ children, margin, width, padding, loading }) => {
    const { t } = useTranslation();
    const content = (
        <>
            <MediaQuery devices={["desktop"]}>
                <HeaderContainer loading={loading}>
                    <ItemsContainer>
                        <img
                            alt={"SiSU Health"}
                            data-testid="header-logo-without-menu"
                            src={`${PORTAL_IMAGE}/authenticatedHeader/Logo.svg`}
                            onClick={() => window.location.assign(routes.healthHub)}
                        />
                    </ItemsContainer>
                    <ItemsContainer>
                        <LanguageSwitcher />
                        <Button onClick={() => window.location.assign("/")}>
                            {t("members_portal_web.components.base_member_view.no_menu.member_sign_in", "Sign In")}
                        </Button>
                    </ItemsContainer>
                </HeaderContainer>
            </MediaQuery>
            <MediaQuery devices={["mobile", "tablet"]}>
                <MobileLogo>
                    <img
                        alt={"SiSU Health"}
                        data-testid="mobile-header-logo"
                        src={`${PORTAL_IMAGE}/logo-mobile.svg`}
                        onClick={() => window.location.assign("/")}
                    />
                    <LanguageSwitcher />
                    <MemberLogin onClick={() => window.location.assign("/")}>
                        {t("members_portal_web.components.base_member_view.no_menu.member_sign_in", "Sign In")}
                    </MemberLogin>
                </MobileLogo>
            </MediaQuery>
        </>
    );
    return (
        <>
            <ThinHeader data-testid="base-member-without-menu">{content}</ThinHeader>
            <PageContainer id={"page-container"} margin={margin} width={width} padding={padding}>
                {children}
            </PageContainer>
        </>
    );
};

// ----------------------------------------------------------------------------

BaseMemberViewWithoutMenu.displayName = "Page Container Without Member Menu";
BaseMemberViewWithoutMenu.propTypes = {
    children: PropTypes.any,
    margin: PropTypes.string,
    width: PropTypes.string,
    padding: PropTypes.string,
    loading: PropTypes.oneOf([PropTypes.string, PropTypes.bool])
};

export default BaseMemberViewWithoutMenu;
